import React from 'react'
import { Image } from 'utoniq-ui'

type Props = {
  src: string
  alt: string
  withBorderRadius?: boolean
  positionAbsolute?: boolean
}
export const ThumbnailImage = ({
  src,
  alt,
  withBorderRadius = false,
  positionAbsolute = false,
}: Props) => (
  <Image
    style={{
      width: '100%',
      height: '100%',
      borderRadius: withBorderRadius ? '8px' : 'inherit',
      objectFit: 'cover',
      ...(positionAbsolute && {
        position: 'absolute',
      }),
    }}
    alt={alt}
    src={src}
  />
)
